export default "__VITE_ASSET__0bM_nR7A__"